module.exports = __webpack_public_path__ + "img/1.a28f3668.png";